import { dateStyle } from "./settings.js";
export function nowIso() {
	return new Date().toISOString();
}

// Local calendar date ("YYYY-MM-DD") of a Date or ms timestamp.
export function localDate(value = new Date()) {
	const d = value instanceof Date ? value : new Date(value);
	const yyyy = d.getFullYear();
	const mm = String(d.getMonth() + 1).padStart(2, "0");
	const dd = String(d.getDate()).padStart(2, "0");
	return `${yyyy}-${mm}-${dd}`;
}

export function todayDate() {
	return localDate(new Date());
}

// "YYYY-MM-DD" shifted by `days` (negative = earlier). UTC arithmetic so DST
// never nudges the calendar day. Null for anything that isn't a date string.
export function shiftDate(isoDate, days) {
	const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(isoDate ?? "");
	if (!m) return null;
	const t = Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]) + days);
	return new Date(t).toISOString().slice(0, 10);
}

export function formatDate(iso) {
	if (!iso) return "—";
	const d = new Date(iso);
	if (Number.isNaN(d.getTime())) return iso;
	const style = dateStyle();
	if (style.iso) return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
	return d.toLocaleDateString(style.locale, {
		year: "numeric",
		month: "short",
		day: "numeric",
	});
}

// Format a date-only "YYYY-MM-DD" string (e.g. a release date) without the
// timezone shift `new Date("YYYY-MM-DD")` introduces (it parses as UTC
// midnight, which can roll back a day in negative offsets).
export function formatReleaseDate(dateStr) {
	if (!dateStr) return "";
	const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateStr);
	if (!m) return dateStr;
	const [, y, mo, d] = m;
	const local = new Date(Number(y), Number(mo) - 1, Number(d));
	if (Number.isNaN(local.getTime())) return dateStr;
	const style = dateStyle();
	if (style.iso) return dateStr;
	return local.toLocaleDateString(style.locale, {
		year: "numeric",
		month: "short",
		day: "numeric",
	});
}

// A release date at the precision the source gave it: "21 Oct 2026" (day),
// "Oct 2026" (month), "Q4 2026" (quarter), "2027" (year) or "TBD".
export function formatReleaseWhen(dateStr, precision) {
	if (!dateStr) return precision === "tbd" ? "TBD" : "";
	const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateStr);
	if (!m || !precision || precision === "day") return formatReleaseDate(dateStr);
	const [, y, mo] = m;
	if (precision === "year") return y;
	if (precision === "quarter") return `Q${Math.ceil(Number(mo) / 3)} ${y}`;
	if (precision === "month") {
		const style = dateStyle();
		if (style.iso) return `${y}-${mo}`;
		return new Date(Number(y), Number(mo) - 1, 1).toLocaleDateString(style.locale, { month: "short", year: "numeric" });
	}
	if (precision === "tbd") return "TBD";
	return formatReleaseDate(dateStr);
}
